export default __webpack_public_path__ + "static/media/rightArrowHC.6953c9c6.svg";